import { concat, of } from 'rxjs';

import { actions as bootstrapActions } from '@ezugi/bootstrap';

const { notificationActions: { notification }, roundActions: { round } } = bootstrapActions;

export default function handleSkipPYBTimer(_socketMessage, _state) {
  return concat(
    of(round.set({ roundSkippedPYB: true })),
    of(notification.add({ message: 'messages.skip_pyb_message' }))
  );
}
